export const validateCustomFields = (
  vendorName,
  creditAccounts,
  debitAccounts,
  selectTemplateView,
  overDueBoolean,
  accountCategory,
  overDueDays,
  taggedInvoice,
  invoiceOrNoteNumber,
  accountCode,
  transactionType,
  eInvoiceGeneration,
  eInvoiceGenerationImmediate,
  invDocType
) => {
  let customErrors = {};

  // Checking for required fields
  if (!vendorName) customErrors.vendorName = true;
  if (creditAccounts.length < 1) customErrors.creditAccounts = true;
  if (debitAccounts.length < 1) customErrors.debitAccounts = true;
  if (selectTemplateView === null) customErrors.selectTemplateView = true;
  // if (!overDueBoolean) customErrors.overDueBoolean = true;
  // if (!accountCategory) customErrors.accountCategory = true;
  // if (!overDueBoolean && !accountCategory && overDueDays < 1)
  //   customErrors.overDueDays = true;
  // if (!taggedInvoice) customErrors.taggedInvoice = true;
  // if (!invoiceOrNoteNumber) customErrors.invoiceOrNoteNumber = true;
  // if (!accountCode) customErrors.accountCode = true;
  // if (!transactionType) customErrors.transactionType = true;
  if (!invDocType) customErrors.invoiceDoc = true;
  return customErrors;
};

export const templateViewList = [
  { id: 1, name: "Journal", alias: "JOURNAL" },
  { id: 2, name: "Purchase", alias: "PURCHASE" },
  { id: 3, name: "Sale", alias: "SALE" },
  { id: 4, name: "Bank Payment Voucher", alias: "BANK_PAYMENT_VOUCHER" },
  { id: 5, name: "Contra Voucher", alias: "CONTRA_VOUCHER" },
];

export const eInvoiceViewList = [
  { id: 1, name: "Layer 1", alias: "layer1" },
  { id: 2, name: "Layer 2", alias: "layer2" },
  { id: 3, name: "Sales", alias: "SALE" },
  { id: 4, name: "Payment", alias: "BANK_PAYMENT_VOUCHER" },
  { id: 5, name: "Contra", alias: "CONTRA_VOUCHER" },
];

export const accountTypeConfigValidation = (
  isSourceValidation,
  sourceAccountType,
  sourceAccountTypeChildList
) => {
  let errors = {};
  if (isSourceValidation) {
    if (!sourceAccountType) errors.sourceAccountType = true;
    if (!sourceAccountTypeChildList) errors.sourceAccountTypeChildList = true;
    return errors;
  }
  if (!isSourceValidation) {
    if (!sourceAccountType) errors.targetAccountType = true;
    if (!sourceAccountTypeChildList) errors.targetAccountTypeChildList = true;
    return errors;
  }
};

export const voucherTypeList = [
  { id: 1, name: "Sales", alias: true },
  { id: 2, name: "Purchase", alias: false },
  // { id: 3, name: "Payment", alias: null },
  // { id: 4, name: "Receipt", alias: null },
  // { id: 5, name: "Journal", alias: null },
  // { id: 6, name: "Contra", alias: null },
  // { id: 7, name: "Debit Note", alias: null },
  // { id: 8, name: "Credit Note", alias: null },
  { id: 3, name: "Others", alias: null },
];
